import React from 'react';

interface CardProps {
  children: React.ReactNode;
  padding?: number;
  radius?: number;
  style?: React.CSSProperties;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  role?: string;
  tabIndex?: number;
}

const Card: React.FC<CardProps> = ({ children, padding = 16, radius = 12, style, className, onClick, role, tabIndex }) => {
  return (
    <div
      className={className}
      onClick={onClick}
      role={role}
      tabIndex={tabIndex}
      style={{
        background: 'var(--color-surface)',
        borderRadius: radius,
        padding,
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        border: '1px solid var(--color-border)',
        ...style,
      }}
    >
      {children}
    </div>
  );
};

export default Card;
